import React, { useState, useEffect, useRef, useMemo } from "react";
import { ThreadSearch, GlobalMessageSearch } from "./ChatSearch";
import { sendNotification } from "./notify";
import { db } from "../firebase";
import {
  collection, addDoc, onSnapshot, query, orderBy,
  doc, updateDoc, deleteDoc, serverTimestamp, setDoc, getDoc, getDocs
} from "firebase/firestore";
import axios from "axios";

const CLOUD_NAME = "dscxfsvrf";
const UPLOAD_PRESET = "ficsori-portal";
const ADMIN_NAME = "Frank Ficsori";
const ADMIN_EMAIL = "frank@ficsoriaccounting.com";

const S = {
  btn:{fontSize:12,padding:"5px 12px",borderRadius:8,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnPrimary:{fontSize:12,padding:"5px 12px",borderRadius:8,border:"none",background:"#C0111F",color:"#fff",cursor:"pointer",fontFamily:"sans-serif"},
  btnSm:{fontSize:11,padding:"3px 8px",borderRadius:6,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer"},
  input:{width:"100%",padding:"7px 10px",fontSize:13,border:"0.5px solid #ccc",borderRadius:8,fontFamily:"sans-serif",background:"#fff",boxSizing:"border-box"},
};

function formatTime(ts){
  if(!ts) return "";
  const d = ts.toDate ? ts.toDate() : new Date(ts);
  const now = new Date();
  const diff = now - d;
  if(diff < 60000) return "just now";
  if(diff < 3600000) return Math.floor(diff/60000)+"m ago";
  if(diff < 86400000) return d.toLocaleTimeString("en-US",{hour:"numeric",minute:"2-digit"});
  return d.toLocaleDateString("en-US",{month:"short",day:"numeric",year:"numeric"});
}

function linkify(text){
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const parts = text.split(urlRegex);
  return parts.map((part,i)=>
    urlRegex.test(part)
      ? <a key={i} href={part} target="_blank" rel="noreferrer" style={{color:"inherit",textDecoration:"underline",opacity:0.85}}>{part}</a>
      : part
  );
}

function MessageBubble({ msg, isOwn, isAdmin, onEdit, onDelete, editingId, editText, setEditText, onSaveEdit, onCancelEdit }){
  const [showActions, setShowActions] = useState(false);
  const isEditing = editingId === msg.firestoreId;
  const canEdit = isOwn || isAdmin;
  const canDelete = isOwn || isAdmin;

  return (
    <div style={{display:"flex",gap:8,marginBottom:4,flexDirection:isOwn?"row-reverse":"row",alignItems:"flex-end"}}
      onMouseEnter={()=>setShowActions(true)}
      onMouseLeave={()=>setShowActions(false)}>
      <div style={{maxWidth:"70%"}}>
        {isEditing ? (
          <div style={{background:"#f5f5f0",borderRadius:12,padding:"8px 10px",minWidth:220}}>
            <textarea style={{...S.input,resize:"none",minHeight:60,fontSize:12}} value={editText}
              onChange={e=>setEditText(e.target.value)} autoFocus rows={2}
              onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();onSaveEdit(msg);}if(e.key==="Escape")onCancelEdit();}}/>
            <div style={{display:"flex",gap:6,marginTop:4}}>
              <button onClick={()=>onSaveEdit(msg)} style={{...S.btnSm,background:"#C0111F",color:"#fff",border:"none",fontSize:11}}>Save</button>
              <button onClick={onCancelEdit} style={{...S.btnSm,fontSize:11}}>Cancel</button>
            </div>
          </div>
        ) : (
          <div style={{position:"relative"}}>
            {/* Attachment */}
            {msg.attachment && (
              <div style={{marginBottom:4}}>
                {msg.attachmentType==="image"
                  ? <img src={msg.attachmentUrl} alt={msg.attachment} style={{maxWidth:220,maxHeight:180,borderRadius:8,display:"block"}}/>
                  : <div style={{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",background:isOwn?"rgba(255,255,255,0.15)":"#e0dfd8",borderRadius:8,cursor:"pointer"}} onClick={()=>window.open(msg.attachmentUrl,"_blank")}>
                      <span style={{fontSize:20}}>📎</span>
                      <div><div style={{fontSize:12,fontWeight:500}}>{msg.attachment}</div><div style={{fontSize:11,opacity:0.7}}>Click to open</div></div>
                    </div>
                }
              </div>
            )}
            {/* Message text */}
            {msg.text && (
              <div style={{position:"relative",display:"inline-block"}} className="msg-bubble-wrap">
              <div style={{
                background:isOwn?"#C0111F":"#f5f5f0",
                color:isOwn?"#fff":"#1a1a18",
                padding:"9px 13px",
                borderRadius:isOwn?"14px 14px 2px 14px":"14px 14px 14px 2px",
                fontSize:13,lineHeight:1.6,wordBreak:"break-word"
              }}>
                {linkify(msg.text)}
              </div>
              <span
                title="Copy message"
                className="msg-copy-btn"
                onClick={(e)=>{ e.stopPropagation(); navigator.clipboard.writeText(msg.text||""); const t=e.currentTarget; t.textContent="✓"; setTimeout(()=>t.textContent="⧉",1500); }}
                style={{position:"absolute",top:4,right:4,cursor:"pointer",fontSize:11,padding:"1px 5px",background:"rgba(255,255,255,0.85)",borderRadius:4,border:"0.5px solid #ccc",opacity:0.55,transition:"opacity 0.2s",fontWeight:500}}
              >⧉</span>
            </div>
            )}
            {msg.edited&&<div style={{fontSize:10,color:"#aaa",marginTop:1,textAlign:isOwn?"right":"left",fontStyle:"italic"}}>(edited)</div>}
            <div style={{display:"flex",alignItems:"center",gap:6,marginTop:2,justifyContent:isOwn?"flex-end":"flex-start"}}>
              <span style={{fontSize:10,color:"#aaa"}}>{formatTime(msg.createdAt)}</span>
                {isOwn && msg.readAt && <span style={{fontSize:10,color:"#3B6D11"}} title={"Read "+formatTime(msg.readAt)}>✓✓ Read</span>}
              {isOwn && !msg.readAt && <span style={{fontSize:10,color:"#aaa"}} title="Delivered">✓ Sent</span>}
            </div>
            {/* Action buttons on hover */}
            {showActions && (canEdit || canDelete) && !isEditing && (
              <div style={{position:"absolute",top:-28,[isOwn?"left":"right"]:0,display:"flex",gap:3,background:"#fff",border:"0.5px solid #e0dfd8",borderRadius:8,padding:"3px 5px",boxShadow:"0 2px 8px rgba(0,0,0,0.1)",zIndex:10}}>
                {canEdit&&<span title="Edit" onClick={()=>onEdit(msg)} style={{cursor:"pointer",fontSize:13,padding:"2px 4px",borderRadius:4}} onMouseEnter={e=>e.currentTarget.style.background="#f5f5f0"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>✏</span>}
                <span title="Copy" onClick={(e)=>{ e.stopPropagation(); navigator.clipboard.writeText(msg.text||""); e.currentTarget.textContent="✓"; setTimeout(()=>e.currentTarget.textContent="⧉",1200); }} style={{cursor:"pointer",fontSize:11,padding:"2px 6px",background:"rgba(255,255,255,0.9)",borderRadius:4,border:"0.5px solid #e0dfd8",boxShadow:"0 1px 3px rgba(0,0,0,0.1)",fontFamily:"monospace",fontWeight:500}}>⧉</span>
                {canDelete&&<span title="Delete" onClick={()=>onDelete(msg)} style={{cursor:"pointer",fontSize:13,padding:"2px 4px",borderRadius:4,color:"#C0111F"}} onMouseEnter={e=>e.currentTarget.style.background="#fdf0f0"} onMouseLeave={e=>e.currentTarget.style.background="transparent"}>🗑</span>}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

// Thread component — shared between admin and client views
function MessageThread({ threadId, currentUserName, isAdmin, otherName, onBack }){
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [subject, setSubject] = useState("");
  const [showSubject, setShowSubject] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [editText, setEditText] = useState("");
  const bottomRef = useRef();
  const scrollContainerRef = useRef();
  const inputRef = useRef();
  const fileRef = useRef();
  const searchRef = useRef();
  const messageRefs = useRef({});
  const isOwn = (msg) => msg.senderName === currentUserName;

  const jumpToMessage = (id) => {
    const el = messageRefs.current[id];
    if(el){ el.scrollIntoView({behavior:"smooth",block:"center"}); el.style.background="#FFF3CD"; setTimeout(()=>el.style.background="transparent",2000); }
  };

  useEffect(()=>{
    if(!threadId) return;
    const q = query(collection(db,"messages",threadId,"thread"), orderBy("createdAt","asc"));
    const unsub = onSnapshot(q, snap=>{
      const msgs = snap.docs.map(d=>({...d.data(),firestoreId:d.id}));
      setMessages(msgs);
      // Mark messages from other party as read
      msgs.filter(m=>m.senderName!==currentUserName&&!m.readAt).forEach(async m=>{
        try{ await updateDoc(doc(db,"messages",threadId,"thread",m.firestoreId),{readAt:new Date().toISOString()}); }catch(e){}
      });
    });
    return ()=>unsub();
  },[threadId, currentUserName]);

  useEffect(()=>{
    const cont = scrollContainerRef.current;
    if(cont){ const near = cont.scrollHeight - cont.scrollTop - cont.clientHeight < 150; if(near) bottomRef.current?.scrollIntoView({behavior:"smooth"}); } else { bottomRef.current?.scrollIntoView({behavior:"smooth"}); }
  },[messages.length]);

  const sendMessage = async () => {
    if(!input.trim() && !subject) return;
    try{
      await addDoc(collection(db,"messages",threadId,"thread"),{
        text: input.trim(),
        subject: subject||null,
        senderName: currentUserName,
        senderIsAdmin: isAdmin,
        createdAt: serverTimestamp(),
        readAt: null,
      });
      // Update thread metadata
      await setDoc(doc(db,"messages",threadId),{
        lastMessage: input.trim()||"[Attachment]",
        lastMessageAt: new Date().toISOString(),
        lastSender: currentUserName,
        clientName: isAdmin ? otherName : currentUserName,
        unreadByAdmin: !isAdmin,
        unreadByClient: isAdmin,
      },{merge:true});
      // Send email notification
      if(isAdmin && input.trim()){
        sendNotification("new_message_to_client",{
          recipientEmail: "lookup", // Cloud Function will look up by clientName
          recipientName: otherName,
          senderName: currentUserName,
          clientName: otherName,
          details: input.trim().slice(0,200),
          portalUrl: "https://portal.ficsoriaccounting.com/#messages",
        });
      } else if(!isAdmin && input.trim()){
        sendNotification("client_message",{
          recipientEmail: "frank@ficsoriaccounting.com",
          recipientName: "Frank Ficsori",
          clientName: currentUserName,
          details: input.trim().slice(0,200),
        });
      }
      setInput("");
      setSubject("");
      setShowSubject(false);
    }catch(e){ alert("Failed to send: "+e.message); }
  };

  const uploadAttachment = async (file) => {
    setUploading(true);
    try{
      const isImage = file.type.startsWith("image/");
      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", UPLOAD_PRESET);
      formData.append("folder", `ficsori-portal/messages/${threadId}`);
      const res = await axios.post(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/auto/upload`, formData);
      await addDoc(collection(db,"messages",threadId,"thread"),{
        text: "",
        attachment: file.name,
        attachmentUrl: res.data.secure_url,
        attachmentType: isImage?"image":"file",
        senderName: currentUserName,
        senderIsAdmin: isAdmin,
        createdAt: serverTimestamp(),
        readAt: null,
      });
      await setDoc(doc(db,"messages",threadId),{
        lastMessage: "📎 "+file.name,
        lastMessageAt: new Date().toISOString(),
        lastSender: currentUserName,
        clientName: isAdmin ? otherName : currentUserName,
        unreadByAdmin: !isAdmin,
        unreadByClient: isAdmin,
      },{merge:true});
    }catch(e){ alert("Failed to upload: "+e.message); }
    setUploading(false);
  };

  const deleteMessage = async (msg) => {
    if(!window.confirm("Delete this message?")) return;
    try{ await deleteDoc(doc(db,"messages",threadId,"thread",msg.firestoreId)); }
    catch(e){ alert("Failed: "+e.message); }
  };

  const saveEdit = async (msg) => {
    if(!editText.trim()) return;
    try{
      await updateDoc(doc(db,"messages",threadId,"thread",msg.firestoreId),{
        text: editText.trim(), edited:true, editedAt:new Date().toISOString()
      });
      setEditingId(null); setEditText("");
    }catch(e){ alert("Failed: "+e.message); }
  };

  return (
    <div style={{display:"flex",flexDirection:"column",height:"100%",overflow:"hidden",minHeight:0}}>
      {/* Thread header */}
      <div style={{padding:"12px 16px",borderBottom:"0.5px solid #e0dfd8",display:"flex",alignItems:"center",gap:10,flexShrink:0,background:"#fff"}}>
        {onBack&&<button style={{...S.btnSm,fontSize:13}} onClick={onBack}>←</button>}
        <div style={{flex:1}}/>
        <ThreadSearch messages={messages} onJumpTo={jumpToMessage} searchRef={searchRef}/>
        <div style={{width:32,height:32,borderRadius:"50%",background:"#fdf0f0",color:"#C0111F",display:"flex",alignItems:"center",justifyContent:"center",fontSize:12,fontWeight:500,flexShrink:0}}>
          {(otherName||"?").split(" ").map(w=>w[0]).join("").slice(0,2).toUpperCase()}
        </div>
        <div>
          <div style={{fontSize:13,fontWeight:500}}>{otherName}</div>
          <div style={{fontSize:11,color:"#888"}}>{isAdmin?"Client":"Ficsori Accounting"}</div>
        </div>
      </div>

      {/* Messages */}
      <div ref={scrollContainerRef} style={{flex:1,overflowY:"auto",padding:"16px",display:"flex",flexDirection:"column",userSelect:"text",WebkitUserSelect:"text",MozUserSelect:"text",cursor:"auto"}}>
        {messages.length===0&&(
          <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",color:"#aaa",gap:8}}>
            <div style={{fontSize:32}}>💬</div>
            <div style={{fontSize:13,fontWeight:500}}>No messages yet</div>
            <div style={{fontSize:12}}>Start the conversation below</div>
          </div>
        )}
        {messages.map((msg,i)=>{
          const own = isOwn(msg);
          const prev = messages[i-1];
          const showName = !prev || prev.senderName !== msg.senderName;
          return (
            <div key={msg.firestoreId} ref={el=>messageRefs.current[msg.firestoreId]=el} style={{transition:"background 0.5s"}}>
              {msg.subject&&<div style={{textAlign:"center",margin:"8px 0"}}><span style={{fontSize:11,padding:"3px 10px",background:"#f5f5f0",borderRadius:20,color:"#888"}}>Re: {msg.subject}</span></div>}
              {showName&&!own&&<div style={{fontSize:11,color:"#888",marginBottom:2,marginLeft:4}}>{msg.senderName}</div>}
              <MessageBubble
                msg={msg} isOwn={own} isAdmin={isAdmin}
                onEdit={(m)=>{setEditingId(m.firestoreId);setEditText(m.text);}}
                onDelete={deleteMessage}
                editingId={editingId} editText={editText}
                setEditText={setEditText}
                onSaveEdit={saveEdit}
                onCancelEdit={()=>{setEditingId(null);setEditText("");}}
              />
            </div>
          );
        })}
        <div ref={bottomRef}/>
      </div>

      {/* Input area */}
      <div style={{padding:"10px 14px",borderTop:"0.5px solid #e0dfd8",background:"#fff",flexShrink:0}}>
        {showSubject&&(
          <div style={{marginBottom:8}}>
            <input style={{...S.input,fontSize:12}} value={subject} onChange={e=>setSubject(e.target.value)} placeholder="Subject (optional)" autoFocus/>
          </div>
        )}
        <div style={{display:"flex",gap:8,alignItems:"flex-end"}}>
          <div style={{flex:1,position:"relative"}}>
            <textarea
              value={input} onChange={e=>setInput(e.target.value)}
              onKeyDown={e=>{if(e.key==="Enter"&&!e.shiftKey){e.preventDefault();sendMessage();}}}
              placeholder="Type a message... Enter to send, Shift+Enter for new line"
              style={{...S.input,resize:"none",minHeight:38,maxHeight:120,overflowY:"auto",paddingRight:8,lineHeight:1.5,fontSize:12}}
              rows={1}
            />
          </div>
          <button title="Add subject" onClick={()=>setShowSubject(s=>!s)} style={{...S.btnSm,height:38,padding:"0 10px",color:showSubject?"#C0111F":"#888",flexShrink:0}}>≡</button>
          <button title="Attach file" onClick={()=>!uploading&&fileRef.current.click()} style={{...S.btnSm,height:38,padding:"0 10px",flexShrink:0}} disabled={uploading}>{uploading?"⏳":"📎"}</button>
          <input ref={fileRef} type="file" style={{display:"none"}} onChange={e=>{if(e.target.files[0])uploadAttachment(e.target.files[0]);e.target.value="";}}/>
          <button onClick={sendMessage} disabled={!input.trim()} style={{...S.btnPrimary,height:38,paddingLeft:14,paddingRight:14,flexShrink:0}}>Send ↑</button>
        </div>
        <div style={{fontSize:10,color:"#aaa",marginTop:4}}>Enter to send · Shift+Enter for new line · 📎 attach · ≡ add subject</div>
      </div>
    </div>
  );
}

// Admin Messages inbox
export default function Messages({ isAdmin, currentUserName, assignedClients }){
  const [threads, setThreads] = useState([]);
  const [activeThread, setActiveThread] = useState(null);

  useEffect(()=>{
    const pending = localStorage.getItem("ficsori_message_client");
    if(pending && isAdmin){
      localStorage.removeItem("ficsori_message_client");
      setTimeout(()=>startNewThread(pending), 500);
    }
  },[threads]);
  const [search, setSearch] = useState("");
  const myName = currentUserName || ADMIN_NAME;

  useEffect(()=>{
    const unsub = onSnapshot(collection(db,"messages"), snap=>{
      const list = snap.docs.map(d=>({...d.data(),firestoreId:d.id}));
      list.sort((a,b)=>(b.lastMessageAt||"").localeCompare(a.lastMessageAt||""));
      setThreads(list);
    });
    return ()=>unsub();
  },[]);

  // Mark thread as read when opened
  useEffect(()=>{
    if(!activeThread) return;
    const field = isAdmin ? "unreadByAdmin" : "unreadByClient";
    updateDoc(doc(db,"messages",activeThread.firestoreId),{[field]:false}).catch(()=>{});
  },[activeThread]);

  const unreadCount = threads.filter(t=>isAdmin?t.unreadByAdmin:t.unreadByClient).length;

  const filtered = threads.filter(t=>
    !search || (t.clientName||"").toLowerCase().includes(search.toLowerCase())
  );

  const openThread = (thread) => setActiveThread(thread);

  const deleteThread = async (e, thread) => {
    e.stopPropagation();
    if(!window.confirm(`Delete conversation with ${thread.clientName}? All messages will be permanently deleted.`)) return;
    try{
      // Delete all messages in thread
      const msgs = await getDocs(collection(db,"messages",thread.firestoreId,"thread"));
      for(const m of msgs.docs) await deleteDoc(doc(db,"messages",thread.firestoreId,"thread",m.id));
      await deleteDoc(doc(db,"messages",thread.firestoreId));
      if(activeThread?.firestoreId===thread.firestoreId) setActiveThread(null);
    }catch(e){ alert("Failed to delete: "+e.message); }
  };

  const startNewThread = async (clientName) => {
    const threadId = clientName.replace(/\s+/g,"_").replace(/[^a-zA-Z0-9_]/g,"");
    const existing = threads.find(t=>t.clientName===clientName);
    if(existing){ setActiveThread(existing); return; }
    await setDoc(doc(db,"messages",threadId),{
      clientName, lastMessage:"", lastMessageAt:new Date().toISOString(),
      lastSender:"", unreadByAdmin:false, unreadByClient:false,
    });
    setActiveThread({firestoreId:threadId, clientName});
  };

  return (
    <div style={{display:"flex",height:"calc(100vh - 100px)",border:"0.5px solid #e0dfd8",borderRadius:12,overflow:"hidden",background:"#fff"}}>

      {/* Left panel — thread list */}
      <div style={{width:280,minWidth:280,borderRight:"0.5px solid #e0dfd8",display:"flex",flexDirection:"column"}}>
        <div style={{padding:"12px 14px",borderBottom:"0.5px solid #e0dfd8",flexShrink:0}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:8}}>
            <div style={{fontSize:13,fontWeight:500,display:"flex",alignItems:"center",gap:8}}>
              Messages
              {unreadCount>0&&<span style={{background:"#C0111F",color:"#fff",fontSize:10,padding:"1px 6px",borderRadius:10,fontWeight:500}}>{unreadCount}</span>}
            </div>
            {isAdmin&&(
              <select style={{fontSize:11,padding:"3px 6px",borderRadius:6,border:"0.5px solid #ccc",background:"#fff",cursor:"pointer"}}
                onChange={e=>{if(e.target.value)startNewThread(e.target.value);e.target.value="";}}>
                <option value="">+ New Message</option>
                {(assignedClients||[]).map(c=><option key={c}>{c}</option>)}
              </select>
            )}
          </div>
          <input style={{...S.input,fontSize:11}} placeholder="Search conversations..." value={search} onChange={e=>setSearch(e.target.value)}/>
        </div>

        <div style={{flex:1,overflowY:"auto"}}>
          {filtered.length===0&&(
            <div style={{textAlign:"center",padding:"32px 16px",color:"#aaa",fontSize:12}}>
              {isAdmin?"No conversations yet. Use + New Message to start one.":"No messages yet."}
            </div>
          )}
          {filtered.map(t=>{
            const isActive = activeThread?.firestoreId===t.firestoreId;
            const hasUnread = isAdmin ? t.unreadByAdmin : t.unreadByClient;
            return (
              <div key={t.firestoreId} onClick={()=>openThread(t)} style={{
                padding:"12px 14px",cursor:"pointer",borderBottom:"0.5px solid #f5f5f0",
                background:isActive?"#fdf0f0":hasUnread?"#fafaf8":"transparent",
                borderLeft:isActive?"2px solid #C0111F":hasUnread?"2px solid #FAEEDA":"2px solid transparent",
                position:"relative",
              }}
                onMouseEnter={e=>{if(!isActive)e.currentTarget.style.background="#f5f5f0";e.currentTarget.querySelector(".del-btn").style.opacity=1;}}
                onMouseLeave={e=>{if(!isActive)e.currentTarget.style.background=hasUnread?"#fafaf8":"transparent";e.currentTarget.querySelector(".del-btn").style.opacity=0;}}
              >
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:3}}>
                  <div style={{fontSize:12,fontWeight:hasUnread?600:500,color:isActive?"#C0111F":"#1a1a18",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",flex:1}}>{t.clientName}</div>
                  <div style={{display:"flex",alignItems:"center",gap:4,flexShrink:0}}>
                    <div style={{fontSize:10,color:"#aaa"}}>{t.lastMessageAt?formatTime({toDate:()=>new Date(t.lastMessageAt)}):"—"}</div>
                    <span className="del-btn" onClick={(e)=>deleteThread(e,t)} title="Delete conversation"
                      style={{opacity:0,cursor:"pointer",fontSize:13,color:"#C0111F",padding:"1px 4px",borderRadius:4,transition:"opacity 0.15s"}}
                      onMouseEnter={e=>e.currentTarget.style.background="#fdf0f0"}
                      onMouseLeave={e=>e.currentTarget.style.background="transparent"}>
                      🗑
                    </span>
                  </div>
                </div>
                <div style={{fontSize:11,color:"#888",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap",display:"flex",alignItems:"center",gap:4}}>
                  {hasUnread&&<span style={{width:6,height:6,borderRadius:"50%",background:"#C0111F",flexShrink:0,display:"inline-block"}}/>}
                  {t.lastSender===myName?"You: ":""}{t.lastMessage||"No messages yet"}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Right panel — active thread */}
      <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden"}}>
        {!activeThread?(
          <div style={{flex:1,display:"flex",alignItems:"center",justifyContent:"center",flexDirection:"column",color:"#aaa",gap:8}}>
            {isAdmin&&<div style={{position:"absolute",top:16,right:16}}><GlobalMessageSearch isAdmin={isAdmin} currentUserName={myName}/></div>}
            <div style={{fontSize:40}}>💬</div>
            <div style={{fontSize:14,fontWeight:500,color:"#555"}}>Select a conversation</div>
            <div style={{fontSize:12}}>{isAdmin?"Or start a new message with a client":"Messages from Ficsori Accounting will appear here"}</div>
          </div>
        ):(
          <MessageThread
            threadId={activeThread.firestoreId}
            currentUserName={myName}
            isAdmin={isAdmin}
            otherName={isAdmin ? activeThread.clientName : ADMIN_NAME}
            onBack={null}
          />
        )}
      </div>
    </div>
  );
}
